import { Activity, BodyProps } from '@ofqual/portal-activity-feed';
import { Recipient } from '../../domain/InternalMessageModel';
import { LcmAttachment } from '../../domain/LcmAttachment';
import { LcmExternalCounselRequest } from '../../domain/LcmExternalRequest';
import { CommunicationType } from '../../domain/FutureEventModel';
import { MutableRefObject } from 'react';
import {fieldLabels} from "../sections/fieldlabels";

export interface EntityDialog {
 dialogType: DialogType;
 focusedActivity?: Activity;
}

export enum DialogType {
 ActivityAction,
 AddExternalCounsel,
 ExternalCounselReject,
 ExternalCounselAccept,
 AttachCaseFiles,
 AddTimeRecord,
 AddCaseNote,
 AttachmentEmail,
 AddInternalMessage,
 CloseCase,
 FutureEvent,
 OptionMenuEvent,
 ReopenCase,

 LcmChanged 
}

export type AttachmentActivityBody = {
 subject: string;
 documents: LcmAttachment[];
};

export type AttachmentBodyProps = {
 bodyProps: BodyProps<AttachmentActivityBody>;
};

export type TimeRecordLoggedActivityBody = {
 subject: string;
 name: string;
 externalCounsel: string;
 notes: string;
 duration: number;
 forecast: number;
 requestDate: string;
};

export type InternalMessage = {
 subject: string;
 message: string;
 recipients: Array<Recipient>;
 documents: LcmAttachment[];
};

export type projectPolicyActivity = {
  category: string;
  subCategory :string;
}

export type CaseNoteActivity = {
 note: string;
 noteType: number;
 noteDate: string;
 notedByName: string;
 documents?: LcmAttachment[];
};

export interface ExternalCounselActivityBodyProps
 extends LcmExternalCounselRequest {
 id: number;
 lcmEventType: number;
 status: number;
}

export type EmailAttachment = {
 fileName: string;
 contentType: string;
 blobId: string;
};

export type EmailActivityBody = {
 from: string;
 to: string[];
 cc?: string[];
 bodyText?: string;
 bodyHtml?: string;
 subject: string;
 attachments: EmailAttachment[];
 originalEmailBlobId: string;
 originalFileName: string;
};

export type FutureEventActivity = {
 dateTime: Date;
 eventType: string;
 communicationType: CommunicationType;
 note: string;
};

export type FieldChange = {
 field: keyof typeof fieldLabels;
 oldValue: string | null;
 newValue: string | null;
};

export type ChangeActivityBody = {
 changes: FieldChange[];
};

export type OptionMenuActivity = {
 anchorEl: MutableRefObject<null | React.SyntheticEvent>;
};

export type ActivityDialogProps = {
 activity: Activity;
 onClose: () => void;
};
